import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { v4 as uuidv4 } from 'uuid';

const DEFAULT_STYLES = [
  {
    id: 'modern',
    name: 'Styl1',
    isSystem: true,
    walls: { color: '#000000', thickness: 16 },
    rooms: { fillColor: '#e5e7d0ff', fillOpacity: 50 },
    objects: { stroke: '#000000', fill: '#ffffff' }
  },
  {
    id: 'scandi',
    name: 'Styl2',
    isSystem: true,
    walls: { color: '#5f6b7c', thickness: 16 },
    rooms: { fillColor: '#f0f4f8', fillOpacity: 30 },
    objects: { stroke: '#4a5568', fill: '#ffffff' }
  },
  {
    id: 'industrial',
    name: 'Styl3',
    isSystem: true,
    walls: { color: '#405A76', thickness: 16 },
    rooms: { fillColor: '#94adc7ff', fillOpacity: 60 },
    objects: { stroke: '#405A76', fill: '#e2e8f0' }
  }
];

const useStyleStore = create(
  persist(
    (set) => ({
      styles: DEFAULT_STYLES,
      activeStyleId: 'modern',

      addStyle: (style) => set((state) => ({
        styles: [...state.styles, { ...style, id: uuidv4(), isSystem: false }]
      })),

      updateStyle: (id, updates) => set((state) => ({
        styles: state.styles.map(s => s.id === id ? { ...s, ...updates } : s)
      })),

      deleteStyle: (id) => set((state) => ({
        styles: state.styles.filter(s => s.id !== id)
      })),
      
      setActiveStyleId: (id) => set({ activeStyleId: id }),
      
      resetStyles: () => set({ styles: DEFAULT_STYLES })
    }),
    {
      name: 'floorcraft-styles',
    }
  )
);

export default useStyleStore;